const auditTrailEventType = {
    update: 'Update',
    delete: 'Delete',
    add: 'Add',
    edit: 'Edit',
};
export default auditTrailEventType;
